module.exports = __webpack_public_path__ + "public/img/saoma.cf588530.gif";